<template lang="pug">
  .component-backoffice-coupon-list.row.column
    base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="true",)
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'


  export default {
    name: 'CouponList',
    components: {
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Coupon.vue'),
      }
    },
    created() {

    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        return KeplerBackofficeSdk.coupons.list(page, resultsPerPage).all((data) => {
          callback(data)
        })
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CouponList.vue?17e1ad9e